export const QRCodeSetting = {
  Title: 'QRコード設定',
  Option: {
    Version1: 'バージョン1',
    Version2: 'バージョン2',
  },
  Button: {
    Save: '更新する',
    Processing: '処理中...',
  },
  Dialog: {
    Success: '情報を更新しました。',
    Ok: 'OK',
  },
};
